export default __webpack_public_path__ + "static/media/down.f3f40716.png";